import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../modal';
import Scrubbers from '../scrubbers';

const ModalWithScrubbers = (props) => {
  const {
    startTime,
    endTime,
    children,
    onStartChange,
    onEndChange,
  } = props;

  const anchorTime = startTime + (endTime - startTime) / 2;

  return (
    <>
      <Modal anchorTime={anchorTime}>
        {children}
      </Modal>
      <Scrubbers
        startTime={startTime}
        endTime={endTime}
        onStartChange={onStartChange}
        onEndChange={onEndChange}
      />
    </>
  );
};

ModalWithScrubbers.propTypes = {
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  onStartChange: PropTypes.func,
  onEndChange: PropTypes.func,
  children: PropTypes.node.isRequired,
};

ModalWithScrubbers.defaultProps = {
  onStartChange: null,
  onEndChange: null,
};

export default ModalWithScrubbers;
